var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFluentMdl2BuildQueue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12H16.75V16.75H12V21.5H2.5V12H7.25V7.25H12V2.5H21.5V12ZM10.8125 13.1875H3.6875V20.3125H10.8125V13.1875ZM15.5625 8.4375H8.4375V12H12V15.5625H15.5625V8.4375ZM20.3125 3.6875H13.1875V7.25H16.75V10.8125H20.3125V3.6875Z",
    fill: "#32ED3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentMdl2BuildQueue);
export default __webpack_public_path__ + "static/media/fluent-mdl2_build-queue.cd1eb92c2e4d18299baed4ccd385a410.svg";
export { ForwardRef as ReactComponent };